import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import React from "react";

export default function TextInput({
	maxLength = null,
	message = null,
	name = null,
	placeholder = "",
	label = "",
	type = "text",
	value = "",
	onChange = null,
	disabled = false,
	showCalendarTime = false,
	required = false
}) {
	return type === "text" ? (
		<div className="p-fluid">
			{label} {required ? <span style={{ color: "red" }}>*</span> : ""}
			{/* <div style={{ visibility: "hidden" }}>LOGO</div>   */}
			<InputText
				{...(maxLength ? { maxLength: maxLength } : {})}
				autoComplete="off"
				name={name}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				disabled={disabled}
			/>
			<small style={{ width: "100%" }} className="p-error">
				{message !== null && message[name]}
			</small>
		</div>
	) : (
		<div className="p-fluid">
			<label>
				{label} {required ? <span style={{ color: "red" }}>*</span> : ""}
			</label>
			<Calendar
				disabled={disabled}
				autoComplete="off"
				name={name}
				showTime={showCalendarTime}
				dateFormat="yy-mm-dd"
				value={value}
				onChange={onChange}
				showIcon={true}
			/>
			<small style={{ width: "100%" }} className="p-error">
				{message !== null && message[name]}
			</small>
		</div>
	);
}
